import React from 'react';
import './Bottombar.css';

import logo from './logo.svg'


const Bottombar = () => {
	return <div className="navbar">
	  <a href="https://giraffe.build" ><img src={logo} alt="Giraffe Logo" /></a>
	</div>
}


export default Bottombar;


